<!-- ❗Errors in the form are set on line 60 -->
<script setup>
import { useGenerateImageVariant } from '@core/composable/useGenerateImageVariant'
import authV2LoginIllustrationBorderedDark from '@images/pages/auth-v2-login-illustration-bordered-dark.png'
import authV2LoginIllustrationBorderedLight from '@images/pages/auth-v2-login-illustration-bordered-light.png'
import authV2LoginIllustrationDark from '@images/pages/auth-v2-login-illustration-dark.png'
import authV2LoginIllustrationLight from '@images/pages/auth-v2-login-illustration-light.png'
import authV2MaskDark from '@images/pages/misc-mask-dark.png'
import authV2MaskLight from '@images/pages/misc-mask-light.png'
import { VForm } from 'vuetify/components/VForm'

const authThemeImg = useGenerateImageVariant(authV2LoginIllustrationLight, authV2LoginIllustrationDark, authV2LoginIllustrationBorderedLight, authV2LoginIllustrationBorderedDark, true)
const authThemeMask = useGenerateImageVariant(authV2MaskLight, authV2MaskDark)

definePage({
  meta: {
    layout: 'blank',
    unauthenticatedOnly: true,
  },
})

const isPasswordVisible = ref(false)
const route = useRoute()
const router = useRouter()
const ability = useAbility()

const errors = ref({
  email: undefined,
  password: undefined,
})

const refVForm = ref()

const credentials = ref({
  email: '',
  password: '',
})

const rememberMe = ref(false)

const login = async () => {
  const xsrfToken = useCookie('XSRF-TOKEN').value;
  try {
    const res = await $api('/login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json', // Ensure JSON format
        // 'X-Requested-With': 'XMLHttpRequest', // Important for Laravel
        'X-CSRF-TOKEN': xsrfToken,
      },
      body: {
        email: credentials.value.email,
        password: credentials.value.password,
      },
      onResponseError({ response }) {
        errors.value = response._data.errors
      },
    })
    console.log('res', res)
    const { accessToken, userData, userAbilityRules } = res

    useCookie('userAbilityRules').value = userAbilityRules
    ability.update(userAbilityRules)
    useCookie('userData').value = userData
    useCookie('accessToken').value = accessToken
    console.log('accessToken', accessToken)
    router.push(route.query.to ? String(route.query.to) : '/')
    // await nextTick(() => {
    //   router.replace(route.query.to ? String(route.query.to) : '/')
    // })
  } catch (err) {
    console.error(err)
  }
}

const onSubmit = () => {
  refVForm.value?.validate().then(({ valid: isValid }) => {
    if (isValid)
      login()
  })
}
</script>

<template>
  <!--
    <RouterLink to="/">
    <div class="auth-logo d-flex align-center gap-x-3">
    <VNodeRenderer :nodes="themeConfig.app.logo" />
    <h1 class="auth-title">
    {{ themeConfig.app.title }}
    </h1>
    </div>
    </RouterLink> 
  -->

  <VRow
    no-gutters
    class="auth-wrapper bg-surface fo-login"
  >
    <!--
      <VCol
      md="8"
      class="d-none d-md-flex"
      >
      <div class="position-relative bg-background w-100 me-0">
      <div
      class="d-flex align-center justify-center w-100 h-100"
      style="padding-inline: 6.25rem;"
      >
      <VImg
      max-width="613"
      :src="authThemeImg"
      class="auth-illustration mt-16 mb-2"
      />
      </div>

      <img
      class="auth-footer-mask"
      :src="authThemeMask"
      alt="auth-footer-mask"
      height="280"
      width="100"
      >
      </div>
      </VCol> 
    -->

    <VCol
      cols="12"
      md="4"
      class="auth-card-v2 d-flex align-center justify-center"
    >
      <VCard
        flat
        :max-width="500"
        class="mt-12 mt-sm-0 pa-4"
      >
        <div class="fo-gradient-border">
          <span /><span /><span />
        </div>
        <!--
          <VCardText>
          <h4 class="text-h4 mb-1">
          Welcome to <span class="text-capitalize"> {{ themeConfig.app.title }} </span>! 👋🏻
          </h4>
          <p class="mb-0">
          Please sign-in to your account and start the adventure
          </p>
          </VCardText>
          <VCardText>
          <VAlert
          color="primary"
          variant="tonal"
          >
          <p class="text-sm mb-2">
          Admin Email: <strong>admin@demo.com</strong> / Pass: <strong>admin</strong>
          </p>
          <p class="text-sm mb-0">
          Client Email: <strong>client@demo.com</strong> / Pass: <strong>client</strong>
          </p>
          </VAlert>
          </VCardText> 
        -->
        <VCardText class="fo-login-title">
          <h2><em>FarmOptim</em></h2>
          <h2>Login</h2>
        </VCardText>
        <VCardText>
          <VForm
            ref="refVForm"
            @submit.prevent="onSubmit"
          >
            <VRow>
              <!-- email -->
              <VCol cols="12">
                <AppTextField
                  v-model="credentials.email"
                  label="Email"
                  placeholder="johndoe@email.com"
                  type="email"
                  autofocus
                  :rules="[requiredValidator, emailValidator]"
                  :error-messages="errors.email"
                />
              </VCol>

              <!-- password -->
              <VCol cols="12">
                <AppTextField
                  v-model="credentials.password"
                  label="Password"
                  placeholder="············"
                  :rules="[requiredValidator]"
                  :type="isPasswordVisible ? 'text' : 'password'"
                  :error-messages="errors.password"
                  :append-inner-icon="isPasswordVisible ? 'tabler-eye-off' : 'tabler-eye'"
                  @click:append-inner="isPasswordVisible = !isPasswordVisible"
                />

                <div class="d-flex align-center flex-wrap justify-space-between my-6">
                  <VCheckbox
                    v-model="rememberMe"
                    label="Remember me"
                  />
                  <!--
                    <RouterLink
                    class="text-primary ms-2 mb-1"
                    :to="{ name: 'forgot-password' }"
                    >
                    Forgot Password?
                    </RouterLink> 
                  -->
                </div>

                <VBtn
                  block
                  type="submit"
                >
                  Login
                </VBtn>
              </VCol>

              <!-- create account -->
              <!--
                <VCol
                cols="12"
                class="text-center"
                >
                <span>New on our platform?</span>
                <RouterLink
                class="text-primary ms-1"
                :to="{ name: 'register' }"
                >
                Create an account
                </RouterLink>
                </VCol>
                <VCol
                cols="12"
                class="d-flex align-center"
                >
                <VDivider />
                <span class="mx-4">or</span>
                <VDivider />
                </VCol> 
              -->

              <!-- auth providers -->
              <!--
                <VCol
                cols="12"
                class="text-center"
                >
                <AuthProvider />
                </VCol> 
              -->
            </VRow>
          </VForm>
        </VCardText>
      </VCard>
    </VCol>
  </VRow>
</template>

<style lang="scss">
@use "@core-scss/template/pages/page-auth.scss";
</style>
